import Code from "./Code";
import Components from "./Components";
import ComponentTree from "./ComponentTree";
import CustomCSS from "./CustomCSS";
import DocumentProperties from "./DocumentProperties";
import Editor from "./Editor";
import Pages from "./Pages";
import Preview from "./Preview";
import StyleEditor from "./StyleEditor";

const LEFT_WINDOW_WIDTH = 240;
const RIGHT_WINDOW_WIDTH = 300;
const CENTER_WINDOW_DIMENSIONS = {
  width: (width) => width - LEFT_WINDOW_WIDTH - RIGHT_WINDOW_WIDTH,
  height: (height) => height,
};

const windowMap = {
  Pages: {
    component: Pages,
    icon: "fa fa-files-o",
  },
  Components: {
    component: Components,
    icon: "fa fa-cubes",
  },
  Tree: {
    component: ComponentTree,
    icon: "fa fa-folder-tree",
  },
  Editor: {
    component: Editor,
    dimensions: CENTER_WINDOW_DIMENSIONS,
    icon: "fa fa-pencil-square",
  },
  Preview: {
    component: Preview,
    dimensions: CENTER_WINDOW_DIMENSIONS,
    icon: "fa fa-eye",
  },
  Code: {
    component: Code,
    icon: "fa fa-code",
    dimensions: CENTER_WINDOW_DIMENSIONS,
    props: {
      lazy: true,
    },
  },
  Styles: {
    component: StyleEditor,
    icon: "fa fa-border-style",
  },
  "Custom Styles": {
    component: CustomCSS,
    icon: "fa fa-css3",
  },
  "Document Settings": {
    component: DocumentProperties,
    icon: "fa fa-sliders",
  },
};

/**
 * min window dimensions
 */
export const defaultDimensions = {
  height: (height) => height / 2,
  width: 240,
};

export const defaultLayout = {
  tl: {
    pos: {
      height: (height) => height / 2,
      width: LEFT_WINDOW_WIDTH,
    },
    tabs: [{ name: "Pages" }, { name: "Components" }],
  },
  bl: {
    pos: {
      top: (height) => height / 2,
      height: (height) => height / 2,
      width: LEFT_WINDOW_WIDTH,
    },
    tabs: [{ name: "Tree" }],
  },
  c: {
    pos: {
      left: 240,
      ...CENTER_WINDOW_DIMENSIONS,
    },
    tabs: [{ name: "Editor" }, { name: "Preview" }, { name: "Code" }],
  },
  tr: {
    pos: {
      left: (width) => width - RIGHT_WINDOW_WIDTH,
      width: RIGHT_WINDOW_WIDTH,
      height: (height) => height / 2,
    },
    tabs: [{ name: "Styles" }, { name: "Custom Styles" }],
  },
  br: {
    pos: {
      left: (width) => width - RIGHT_WINDOW_WIDTH,
      width: RIGHT_WINDOW_WIDTH,
      top: (height) => height / 2,
      height: (height) => height / 2,
    },
    tabs: [{ name: "Document Settings" }],
  },
};

export default windowMap;
